<div>
    <div class="modal-header">
        <rask-header size="2" id="modalHeader">
            {{header}}
        </rask-header>
    </div>
    <ng-container #container></ng-container>
</div>